export default __webpack_public_path__ + "static/media/benefit-truck-white.afeb3275.svg";